import api from "@/api/apiAlarm";
import { getTimeZone, convertTimeZone } from "@/utils/localeTime";

export default {
  namespaced: true,
  state() {
    return {
      // 이전에 선택한 알람 활성화 상태 및 알람음 조회
      scoreAlarm: [],

      // 알람음 변경
      scoreChk: false, // 알람 활성화 상태
      selectScore: 1, // 알람음 id
      clickScore: null, // 기본음 or Sound N

      // Histories
      scoreHist: [],
    };
  },
  mutations: {
    // 알람음 변경시 id 반영
    chooseScore(state, value) {
      state.selectScore = value;
    },
    // 알람음 변경시 기본음/Sound N 반영
    changeScore(state, value) {
      state.clickScore = value;
    },
    // 알람 활성화 상태 변경
    changeActiveScore(state, payload) {
      state.scoreChk = payload.state;
    },
  },
  actions: {
    // 이전에 선택한 알람음 조회 및 적용
    async getAlarmScore(context) {
      try {
        const result = await api.getScoreAlarm();
        if (result.isSuccess) {
          let data = result.data;
          context.state.scoreAlarm = data;
          context.commit("changeActiveScore", { state: data.active });
          if (data.display.split(" ")[2] === undefined) {
            context.state.selectScore = 1;
          } else {
            context.state.selectScore = Number(data.display.split(" ")[2]) + 1;
          }
        }
      } catch (error) {
        // // console.log("getAlarmScore ", error);
        return;
      }
    },

    // Histories
    async getHistScore(context) {
      try {
        const result = await api.getScoreHistory();
        const regionCode = localStorage.getItem("regionCode");
        const timeZone = getTimeZone(regionCode);

        if (result.isSuccess) {
          let data = result.data;

          for (let i = 0; i < data.length; i++) {
            const localeDate = convertTimeZone(data[i].endDate, timeZone);

            // Format the date
            const year = localeDate.getFullYear();
            const month = String(localeDate.getMonth() + 1).padStart(2, "0");
            const day = String(localeDate.getDate()).padStart(2, "0");
            data[i].Date = `${year}.${month}.${day}`;

            // Format the time
            const hours = String(localeDate.getHours()).padStart(2, "0");
            const minutes = String(localeDate.getMinutes()).padStart(2, "0");
            data[i].Time = `${hours}:${minutes}`;
            data[i].alarmTime = `${hours}:00`;
          }
          // 날짜 기준 데이터 정렬
          data.sort((a, b) => {
            if (a.Date !== b.Date) {
              return new Date(b.Date) - new Date(a.Date);
            } else {
              return b.Time.localeCompare(a.Time);
            }
          });
          context.state.scoreHist = data;
        }
      } catch (error) {
        // // console.log("getHistScore ", error);
        return;
      }
    },
  },
};
